// packages
import { watch } from '@vue/composition-api';

// utils
import { compareTwoArrays } from '@/utils/';

/**
 *
 * Comparação entre valores ( novo valor & anterior )
 *
 * @since 1.0.0
 * @category Hook
 * @param {String / Array} value
 * @param {String / Array} previousValue
 * @returns {Boolean}
 *
 */
const compareValues = ( value, previousValue, isEqual = true ) => {
    let equal = false;

    // se o tipo de valor for 'object' ( array ) é
    // necessário comparar os valores presentes no array, de forma
    // a determinar se é igual ou não.
    // caso não seja 'object', então é só comparar entre si.
    switch ( typeof value ) {
        case 'object':
            equal = isEqual ? compareTwoArrays( value, previousValue ) : !compareTwoArrays( value, previousValue );
            break;
        default:
            equal = isEqual ? ( !previousValue && !value ) || value === previousValue : value !== previousValue;
            break;
    }

    return equal;
};

/**
 *
 * Listener que irá proceder ao reset do valor das inputs
 * quando o utilizador cancelar a acção de edição.
 * Só irá proceder ao reset, quando passar na validação
 * imposta no listener.
 *
 * @since 1.0.0
 * @category Hook
 * @param {Object} props
 * @param {Object} object
 * @param {String} key
 * @param {String} value
 * @returns {Functions}
 *
 */
const reset = ({
    props,
    object,
    key
}) => {
    watch( () => props.reset,
        newReset => {
            const value = props.apiValue?.label || props.defaultValue;

            // só irá proceder o reset dos campos,
            // quando der trigger do reset ( true ) &
            // o valor da input ser diferente do valor da API.
            if ( newReset && compareValues( object[key], value, false ) )
                object[key] = value || '';
        });
};

export {
    compareValues,
    reset
};